import {
  faTimes,
  faCheck,
  faExternalLinkAlt,
  faEllipsisV,
  faPencilAlt,
  faChevronUp,
  faChevronRight,
  faChevronDown,
  faChevronLeft,
  faSort,
  faSortUp,
  faSortDown,
  faUpload,
  faLink,
  faEnvelope,
  faExclamationCircle,
  faKey,
  faPaperPlane,
  faVideo,
  faFilm,
  faPlayCircle,
  faChartLine,
  faInfoCircle,
  faGripLinesVertical,
  faCheckCircle,
  faBan,
  faHome,
  faMicrophone,
  faPlay,
  faWindowClose,
  faStop,
  faCog,
  faBookmark,
  faPlusCircle,
  faVolumeUp,
  faFile,
  faCircle,
  faLock,
  faDownload,
  faFileUpload,
  faPause,
  faUnlock,
  faTimesCircle,
  faSync,
  faVolumeMute,
  faPauseCircle,
  faAngleLeft,
  faAngleRight,
  faCalendarAlt,
  faComment,
  faPhone,
  faNewspaper,
  faArrowLeft,
  faArrowUp,
  faFileExport,
  faArrowAltCircleDown,
  faArrowAltCircleUp,
  faFont,
  faHeading,
  faQuestionCircle,
  faClipboard,
  faCamera,
  faDesktop,
  faTrashAlt,
  faLevelDownAlt,
  faLaughBeam,
  faSmile,
  faMeh,
  faExchangeAlt,
  faFilter,
  faFolderPlus,
  faCopy,
} from '@fortawesome/free-solid-svg-icons';

import createFaIcon from './createFaIcon';

export const LevelDownAltIcon = createFaIcon(faLevelDownAlt);
export const TimesIcon = createFaIcon(faTimes);
export const CheckIcon = createFaIcon(faCheck);
export const ExternalLinkAltIcon = createFaIcon(faExternalLinkAlt);
export const EllipsisVIcon = createFaIcon(faEllipsisV);
export const PencilAltIcon = createFaIcon(faPencilAlt);
export const ChevronUpIcon = createFaIcon(faChevronUp);
export const ChevronRightIcon = createFaIcon(faChevronRight);
export const ChevronDownIcon = createFaIcon(faChevronDown);
export const ChevronLeftIcon = createFaIcon(faChevronLeft);
export const SortIcon = createFaIcon(faSort);
export const SortUpIcon = createFaIcon(faSortUp);
export const SortDownIcon = createFaIcon(faSortDown);
export const UploadIcon = createFaIcon(faUpload);
export const LinkIcon = createFaIcon(faLink);
export const EnvelopeIcon = createFaIcon(faEnvelope);
export const ExclamationCircleIcon = createFaIcon(faExclamationCircle);
export const KeyIcon = createFaIcon(faKey);
export const SendIcon = createFaIcon(faPaperPlane);
export const VideoIcon = createFaIcon(faVideo);
export const FilmIcon = createFaIcon(faFilm);
export const PlayCircleIcon = createFaIcon(faPlayCircle);
export const ChartIcon = createFaIcon(faChartLine);
export const InfoIcon = createFaIcon(faInfoCircle);
export const GripLinesVerticalIcon = createFaIcon(faGripLinesVertical);
export const CheckCircleIcon = createFaIcon(faCheckCircle);
export const BanIcon = createFaIcon(faBan);
export const HomeIcon = createFaIcon(faHome);
export const MicrophoneIcon = createFaIcon(faMicrophone);
export const PlayIcon = createFaIcon(faPlay);
export const CloseIcon = createFaIcon(faWindowClose);
export const StopIcon = createFaIcon(faStop);
export const CogIcon = createFaIcon(faCog);
export const BookmarkIcon = createFaIcon(faBookmark);
export const PlusCircleIcon = createFaIcon(faPlusCircle);
export const VolumeUpIcon = createFaIcon(faVolumeUp);
export const FileIcon = createFaIcon(faFile);
export const CircleIcon = createFaIcon(faCircle);
export const LockIcon = createFaIcon(faLock);
export const DownloadIcon = createFaIcon(faDownload);
export const FileUploadIcon = createFaIcon(faFileUpload);
export const PauseIcon = createFaIcon(faPause);
export const UnlockIcon = createFaIcon(faUnlock);
export const TimesCircleIcon = createFaIcon(faTimesCircle);
export const SycnIcon = createFaIcon(faSync);
export const VolumeMuteIcon = createFaIcon(faVolumeMute);
export const PauseCircleIcon = createFaIcon(faPauseCircle);
export const AngleLeftIcon = createFaIcon(faAngleLeft);
export const AngleRightIcon = createFaIcon(faAngleRight);
export const CalendarAltIcon = createFaIcon(faCalendarAlt);
export const CommentIcon = createFaIcon(faComment);
export const PhoneIcon = createFaIcon(faPhone);
export const NewspaperIcon = createFaIcon(faNewspaper);
export const ArrowLeft = createFaIcon(faArrowLeft);
export const ArrowUp = createFaIcon(faArrowUp);
export const FileExportIcon = createFaIcon(faFileExport);
export const ArrowAltCircleDownIcon = createFaIcon(faArrowAltCircleDown);
export const ArrowAltCircleUpIcon = createFaIcon(faArrowAltCircleUp);
export const FontIcon = createFaIcon(faFont);
export const HeadingIcon = createFaIcon(faHeading);
export const QuestionCircleIcon = createFaIcon(faQuestionCircle);
export const ClipboardIcon = createFaIcon(faClipboard);
export const DesktopIcon = createFaIcon(faDesktop);
export const CameraIcon = createFaIcon(faCamera);
export const DeleteIcon = createFaIcon(faTrashAlt);
export const LaughBeamIcon = createFaIcon(faLaughBeam);
export const SmileIcon = createFaIcon(faSmile);
export const MehIcon = createFaIcon(faMeh);
export const ExchangeIcon = createFaIcon(faExchangeAlt);
export const FilterIcon = createFaIcon(faFilter);
export const FolderPlusIcon = createFaIcon(faFolderPlus);
export const CopyIcon = createFaIcon(faCopy);
